export default __webpack_public_path__ + "static/media/tubeTrailer.523ba873.svg";